import {
    RECEIVE_COLLECTIONS,
    REQUEST_COLLECTIONS,
    SET_COLLECTIONS_ERROR
  } from '../constants/ActionTypes';

const initialState = {
    isFetching: false,
    isLoadingError: false
};

export default function collections(state = initialState, action) {
    switch (action.type) {
        case SET_COLLECTIONS_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_COLLECTIONS:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case RECEIVE_COLLECTIONS:
            return {
                ...state,
                isFetching: false,
                data: action.data
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/collections.js